import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Feedback } from '../models/feedback';

const addFeedbackUrl = '/feedback/addFeedback.html';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  addFeedback(feedback: Feedback): Observable<void> {
    return this.http.post<void>(addFeedbackUrl, feedback);
  }
}
